import { render, staticRenderFns } from "./_best-jili-slots-to-play-in-2025-rtp-bonuses-gameplay.vue?vue&type=template&id=11698662&lang=pug&"
import script from "./_best-jili-slots-to-play-in-2025-rtp-bonuses-gameplay.vue?vue&type=script&lang=js&"
export * from "./_best-jili-slots-to-play-in-2025-rtp-bonuses-gameplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports